import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {openBusinessApp} from '../services/app-flow';
import {execBI} from '../services/bi-events-manager';
import {popupHide} from '../actions/popup';

class ProvisionPopup extends React.Component {

  componentDidMount() {
    execBI('UNIFICATION_PROVISION_OPEN', {app: this.props.data});
  }

  closeFixedPopup(ev, app) {
    if (ev.target === this.popup) {
      execBI('UNIFICATION_PROVISION_CLOSE', {app, closing_method: 'outside'});
      this.props.dispatch(popupHide());
    }
  }

  handleClose(ev, app, closing_method) {
    ev.preventDefault();
    execBI('UNIFICATION_PROVISION_CLOSE', {app, closing_method});
    this.props.dispatch(popupHide());
  }

  handleOpen(ev, app) {
    ev.preventDefault();
    openBusinessApp(app, 0);
    execBI('UNIFICATION_PROVISION_GO_TO_CLICK', {app, origin: 'unification_modal'});
    this.props.dispatch(popupHide());
  }

  render() {
    const app = this.props.data;

    return (
      <div className="permissions fixed-popup fixed-popup-center" ref={(i) => this.popup = i} onClick={(ev) => this.closeFixedPopup(ev, app)}>
        <div className="vertical-align-helper"></div>
        <div className="permission-popup fixed-popup-centered">
          <div className="provision-success-popup">
            <div className="provision-success-message">
              <button type="button" className="close-button" onClick={(ev) => this.handleClose(ev, app, 'x')}><span>&times;</span></button>
              <div className="header">
                <h2><FormattedMessage id="editorProvisionModal.title"/></h2>
                <p className="description"><FormattedMessage id="editorProvisionModal.description" values={{name: app.name}}/></p>
                <div className="provision-img"></div>
              </div>

              <div className="body">
                <div>
                  <div className="instructions">
                    <p><FormattedMessage id="editorProvisionModal.instructions"/></p>
                  </div>
                  <div className="open">
                    <a className="browse-later" onClick={(ev) => this.handleClose(ev, app, 'later')} href="#">
                      <FormattedMessage id="editorProvisionModal.browseLater"/>
                    </a>
                    <a className="goto" onClick={(ev) => this.handleOpen(ev, app)} href="#"><FormattedMessage id="editorProvisionModal.open"/></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  static propTypes = {
    data: PropTypes.object,
    dispatch: PropTypes.func
  }
}

export default connect((state) => ({data: state.popup.data}))(ProvisionPopup);



// WEBPACK FOOTER //
// ./containers/Provision-popup.js